import React from "react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Typography } from "@material-ui/core";
import {
  isBuddy,
  isUser,
  isGroup,
} from "../../../../store/groups-buddies-data/actions";
import UserProfile from "../user-profile";
import GroupProfile from "../group-profile";
import useStyles from "./styles";

export default function OtherProfile() {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { username } = useParams();
  const user = useSelector((state) => state.groupsBuddiesData.isUser);
  const group = useSelector((state) => state.groupsBuddiesData.isGroup);

  useEffect(() => {
    dispatch(isBuddy(username));
    dispatch(isUser(username));
    dispatch(isGroup(username));
  }, [dispatch, username]);

  const ProfileDisplay = () => (group ? <GroupProfile /> : <UserProfile />);

  return user || group ? (
    <ProfileDisplay />
  ) : (
    <Typography className={classes.noUser}>
      The user or group '{username}' does not exist.
    </Typography>
  );
}
